module.exports = __webpack_public_path__ + "static/media/2025-The-Debrief-Feature-Banner-md@2x.85ea4728.jpg";